import React, { useCallback, useMemo } from 'react';
import { useReportState } from 'hooks/use-report-state';
import { RouteComponentProps } from 'react-router';
import { alarmCategoryListDuck } from 'ducks/alarm-category/list';
import {
  alarmCategoryListFilters,
  alarmCategoryListColumns,
  AlarmCategoryListView,
} from './AlarmCategoryListView';
import { EMPTY_FUNC } from 'util/misc';
import { Enum } from 'util/backendapi/models/api.interfaces';
import { patchApi } from 'util/backendapi/fetch';

export function AlarmCategoryListScreen(props: RouteComponentProps) {
  const columns = useMemo(() => {
    return alarmCategoryListColumns({
      refreshList: EMPTY_FUNC,
      retireAlarmCategory: EMPTY_FUNC,
    });
  }, []);

  const retireAlarmCategory = useCallback(async (id: number) => {
    return patchApi(`/alarm-categories/${id}/`, {
      status: Enum.AlarmCategory_STATUS.retired,
    });
  }, []);

  const reportState = useReportState(
    props,
    columns,
    alarmCategoryListFilters,
    alarmCategoryListDuck,
    (state) => state.alarmCategories.list
  );

  return (
    <AlarmCategoryListView
      reportProps={reportState}
      retireAlarmCategory={retireAlarmCategory}
    />
  );
}
